// @flow strict
import * as React from 'react';
import { ModalBase, CloseIcon, type CloseIconColorVariant } from '@ta/modal.core';
import ContainerSheet from './ContainerSheet';
import styles from './FullScreenModal.css';

type Props = {|
  /**
   * Children to render in the fullscreen modal.
   */
  children?: React.Node,

  /**
   * If the close button should be shown.
   */
  enableCloseIcon?: boolean,

  /**
   *  Color of the close icon
   */
  closeIconColor?: CloseIconColorVariant,

  /**
   * Optional. A function to be called when user clicks X. If no callback is passed in, X will not show.
   */
  onClose?: () => mixed,

  /** If true, focus will not automatically shift focus on open. For accessibility reasons, this value should be false */
  disableAutoFocus?: boolean,

  /**
   * If true, background is transparent. Defaults to white background
   */
  transparentBackground?: boolean,
|};

/**
 * A fullscreen, plain modal that simply covers the screen rendering any children you supply it.
 */
const FullScreenModal = ({
  enableCloseIcon = false,
  closeIconColor,
  children,
  onClose,
  disableAutoFocus,
  transparentBackground,
}: Props) => (
  <ModalBase className={styles.modal} disableAutoFocus={disableAutoFocus} hideBackdrop>
    <ContainerSheet transparentBackground={transparentBackground}>
      {children}
      {enableCloseIcon && (
        <CloseIcon onClick={onClose} colorVariant={closeIconColor} onEnterKeyDown={onClose} />
      )}
    </ContainerSheet>
  </ModalBase>
);

export default FullScreenModal;
